import { useState } from 'react';
import './SignatureCakes.css';
import monGuerlainImg from '../../assets/images/siganture_cackes/mon_guerlain.png';
import dragonImg from '../../assets/images/siganture_cackes/dragon.png';
import kingkongImg from '../../assets/images/siganture_cackes/kingkong.png';
import kreatorImg from '../../assets/images/siganture_cackes/kreator.png';
import dagobertImg from '../../assets/images/siganture_cackes/Dagobert.png';
import herbstImg from '../../assets/images/siganture_cackes/Herbst.png';
import meisterImg from '../../assets/images/siganture_cackes/Meister.png';
import turmImg from '../../assets/images/siganture_cackes/Turm.png';
import turm2Img from '../../assets/images/siganture_cackes/Turm2.png';

const galleryItems = [
  { id: 1, src: dragonImg,   alt: 'Dragon' },
  { id: 2, src: kingkongImg, alt: 'King Kong' },
  { id: 3, src: kreatorImg,  alt: 'Kreator' },
  { id: 4, src: dagobertImg, alt: 'Dagobert' },
  { id: 5, src: herbstImg,   alt: 'Herbst' },
  { id: 6, src: meisterImg,  alt: 'Meister' },
  { id: 7, src: turmImg,     alt: 'Turm' },
  { id: 8, src: turm2Img,    alt: 'Turm 2' },
];

function SignatureCakes() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="signature-cakes" className="signature-cakes">
      <div className="signature-cakes__inner">

        <div className="signature-cakes__header">
          <span className="signature-cakes__label">Handwerk &amp; Leidenschaft</span>
          <h2 className="signature-cakes__title">Signature Cakes</h2>
          <div className="signature-cakes__divider" />
        </div>

        <div className="signature-cakes__featured">
          <div
            className="signature-cakes__featured-img-wrap signature-cakes__clickable"
            onClick={() => setLightbox({ src: monGuerlainImg, alt: 'Mon Guerlain Torte' })}
          >
            <img src={monGuerlainImg} alt="Mon Guerlain Torte" className="signature-cakes__featured-img" />
          </div>
          <div className="signature-cakes__featured-content">
            <span className="signature-cakes__cake-number">No. 01</span>
            <h3 className="signature-cakes__cake-name">Mon Guerlain</h3>
            <div className="signature-cakes__cake-divider" />
            <p className="signature-cakes__cake-text">
              Eine Hommage an das berühmte Parfum — zarte Vanille aus Tahiti,
              Lavendelhonig und weiße Schokolade vereinen sich zu einer Torte
              von außergewöhnlicher Eleganz. Jedes Detail ist mit größter
              Sorgfalt von Hand gefertigt.
            </p>
          </div>
        </div>

        <div className="signature-cakes__gallery-header">
          <p className="signature-cakes__gallery-label">Unsere Kreationen</p>
        </div>

        <div className="signature-cakes__gallery">
          {galleryItems.map((item) => (
            <div
              key={item.id}
              className="signature-cakes__gallery-item signature-cakes__clickable"
              onClick={() => setLightbox({ src: item.src, alt: item.alt })}
            >
              <img src={item.src} alt={item.alt} className="signature-cakes__gallery-img" />
            </div>
          ))}
        </div>

        <blockquote className="signature-cakes__quote">
          <p className="signature-cakes__quote-text">„...each bite will transport you to the pâtisseries in France."</p>
          <cite className="signature-cakes__quote-source">Travel Rumors</cite>
        </blockquote>

      </div>

      {lightbox && (
        <div className="signature-cakes__lightbox" onClick={() => setLightbox(null)}>
          <button className="signature-cakes__lightbox-close" onClick={() => setLightbox(null)}>✕</button>
          <img
            src={lightbox.src}
            alt={lightbox.alt}
            className="signature-cakes__lightbox-img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}

export default SignatureCakes;
